import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../Common/LoadingSpinner';

const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');
    const { resetPassword } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            return toast.error('Passwords do not match');
        }

        if (!token) {
            return toast.error('Reset token is missing');
        }

        setLoading(true);

        try {
            const response = await resetPassword(token, password);
            toast.success(response.message || 'Password reset successfully');
            navigate('/login');
        } catch (error) {
            toast.error(error.response?.data?.message || error.message || 'Failed to reset password');
            console.error('Reset password error:', error);
        } finally {
            setLoading(false);
        }
    };

    if (!token) {
        return (
            <div className="auth-page">
                <div className="auth-container">
                    <div className="auth-card">
                        <div className="auth-header">
                            <h2>Invalid Link</h2>
                            <p>This password reset link is invalid or has expired.</p>
                            <Link to="/forgot-password" class="btn btn-primary" style={{ marginTop: '20px', display: 'inline-block', textDecoration: 'none' }}>
                                Request New Link
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-page">
            <div className="floating-shapes">
                {[...Array(6)].map((_, i) => (
                    <div key={i} className="floating-shape"></div>
                ))}
            </div>

            <div className="wave-container">
                <div className="wave"></div>
                <div className="wave"></div>
                <div className="wave"></div>
            </div>

            <div className="auth-container">
                <div className="auth-card">
                    <div className="auth-header">
                        <div className="logo">
                            <img src="/logo.svg" alt="MessagePe" className="auth-logo-img" />
                        </div>
                        <h2>Reset Password</h2>
                        <p>Enter your new password below</p>
                    </div>

                    <form className="auth-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="password" className="form-label">New Password</label>
                            <input
                                type="password"
                                id="password"
                                className="form-control"
                                placeholder="At least 6 characters"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                minLength="6"
                                disabled={loading}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                            <input
                                type="password"
                                id="confirmPassword"
                                className="form-control"
                                placeholder="Confirm your new password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                disabled={loading}
                            />
                        </div>

                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? <LoadingSpinner size="small" /> : 'Update Password'}
                        </button>
                    </form>

                    <div className="auth-footer">
                        <p>Back to <Link to="/login">Sign In</Link></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
